/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getScheduledOrdersConfiguration } from '../fn/scheduled-orders/get-scheduled-orders-configuration';
import { GetScheduledOrdersConfiguration$Params } from '../fn/scheduled-orders/get-scheduled-orders-configuration';
import { ScheduledOrdersConfigCreateResponse } from '../models/scheduled-orders-config-create-response';
import { upsertScheduledOrdersConfiguration } from '../fn/scheduled-orders/upsert-scheduled-orders-configuration';
import { UpsertScheduledOrdersConfiguration$Params } from '../fn/scheduled-orders/upsert-scheduled-orders-configuration';

@Injectable({ providedIn: 'root' })
export class ScheduledOrdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getScheduledOrdersConfiguration()` */
  static readonly GetScheduledOrdersConfigurationPath = '/stores/{storeId}/scheduled-orders';

  /**
   * Gets scheduled orders Configuration for a Store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getScheduledOrdersConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScheduledOrdersConfiguration$Response(params: GetScheduledOrdersConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledOrdersConfigCreateResponse>> {
    return getScheduledOrdersConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets scheduled orders Configuration for a Store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getScheduledOrdersConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScheduledOrdersConfiguration(params: GetScheduledOrdersConfiguration$Params, context?: HttpContext): Observable<ScheduledOrdersConfigCreateResponse> {
    return this.getScheduledOrdersConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScheduledOrdersConfigCreateResponse>): ScheduledOrdersConfigCreateResponse => r.body)
    );
  }

  /** Path part for operation `upsertScheduledOrdersConfiguration()` */
  static readonly UpsertScheduledOrdersConfigurationPath = '/stores/{storeId}/scheduled-orders';

  /**
   * Upsert scheduled orders Configuration for a Store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertScheduledOrdersConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertScheduledOrdersConfiguration$Response(params: UpsertScheduledOrdersConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledOrdersConfigCreateResponse>> {
    return upsertScheduledOrdersConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert scheduled orders Configuration for a Store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertScheduledOrdersConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertScheduledOrdersConfiguration(params: UpsertScheduledOrdersConfiguration$Params, context?: HttpContext): Observable<ScheduledOrdersConfigCreateResponse> {
    return this.upsertScheduledOrdersConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScheduledOrdersConfigCreateResponse>): ScheduledOrdersConfigCreateResponse => r.body)
    );
  }

}
